import { Modal } from '@pesto/ui/components/Modal';
import React from 'react';

import { useModalStore } from '../stores/useModalStore';
import { modalDefinitions } from './modals';

export const ModalContainer: React.FC = () => {
  const stack = useModalStore((s) => s.stack);

  return stack.map(({ id, action, render, dismiss }, index) => (
    <Modal
      key={id}
      isOpen={true}
      onClose={dismiss}
      depth={stack.length - 1 - index}
      stackSize={stack.length}
      {...modalDefinitions[action].options}
    >
      {render(modalDefinitions)}
    </Modal>
  ));
};
